import { SKIP_ANCHOR_TYPES } from "./Create/constants";

export const isCheckboxAnchor = (anchor) =>
  /^\[[A-Z][A-Za-z0-9]*\]$/.test(anchor);

const CHILD_INDEXED_RE = /^([A-Za-z]+)\.(\d+)\.(.+)$/;
const CHILD_LOOP_KEY_RE = /^([A-Za-z]+)\.N\.(.+)$/;

export const getChildLoopGroupKey = (anchor) => {
  const m = anchor.match(CHILD_INDEXED_RE);
  return m ? `${m[1]}.N.${m[3]}` : null;
};

export const getChildLoopIndex = (anchor) => {
  const m = anchor.match(CHILD_INDEXED_RE);
  return m ? Number.parseInt(m[2], 10) : null;
};

export const isChildLoopKey = (key) => CHILD_LOOP_KEY_RE.test(key);

export const isSkipAnchor = (anchor) =>
  anchor
    .split("|")
    .slice(1)
    .some((part) => SKIP_ANCHOR_TYPES.has(part));

export const mappingKeyFor = (anchor) => getChildLoopGroupKey(anchor) || anchor;
